import { isPC as isPcQuery } from 'constants/layout';
import { useEffect, useState } from 'react';

const useMediaQuery = (mediaQuery: string): boolean => {
  const [isVerified, setIsVerified] = useState(
    typeof window === 'object' && 'matchMedia' in window && window.matchMedia(mediaQuery).matches,
  );

  useEffect(() => {
    if ('matchMedia' in window) {
      const mediaQueryList = window.matchMedia(mediaQuery);
      const documentChangeHandler = () => setIsVerified(mediaQueryList.matches);

      try {
        mediaQueryList.addEventListener('change', documentChangeHandler);
      } catch (e) {
        // Safari isn't supporting mediaQueryList.addEventListener
        mediaQueryList.addListener(documentChangeHandler);
      }

      documentChangeHandler();
      return () => {
        try {
          mediaQueryList.removeEventListener('change', documentChangeHandler);
        } catch (e) {
          // Safari isn't supporting mediaQueryList.removeEventListener
          mediaQueryList.removeListener(documentChangeHandler);
        }
      };
    }

    return undefined;
  }, [mediaQuery]);

  return isVerified;
};

export const useMedia = () => {
  const isPc = useMediaQuery(`(${isPcQuery})`);

  return { isPc };
};
